var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _circle, _circle2, _circle3, _rect11, _path2, _rect12, _rect13, _circle4, _rect14, _path3, _rect15, _rect16, _rect17, _rect18, _circle5, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatterns(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 200,
    viewBox: "0 0 300 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 200,
    fill: "#DBEEF2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 29,
    width: 200,
    height: 151,
    rx: 14,
    fill: "#57A4B9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 81H250V166C250 173.732 243.732 180 236 180H64C56.268 180 50 173.732 50 166V81Z",
    fill: "#7FC0CF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 41,
    width: 83,
    height: 16,
    fill: "#7FC0CF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 61,
    width: 68,
    height: 10,
    fill: "#7FC0CF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 139,
    width: 40,
    height: 10,
    fill: "#57A4B9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 139,
    width: 40,
    height: 10,
    fill: "#57A4B9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 153,
    width: 24,
    height: 10,
    fill: "#57A4B9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 153,
    width: 24,
    height: 10,
    fill: "#57A4B9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 153,
    width: 24,
    height: 10,
    fill: "#57A4B9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 139,
    width: 40,
    height: 10,
    fill: "#57A4B9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 112,
    r: 20,
    fill: "#57A4B9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 112,
    r: 20,
    fill: "#57A4B9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 112,
    r: 20,
    fill: "#57A4B9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: -166,
    y: 29,
    width: 200,
    height: 151,
    rx: 14,
    fill: "#87C6D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-166 81H34V166C34 173.732 27.732 180 20 180H-152C-159.732 180 -166 173.732 -166 166V81Z",
    fill: "#ABD7E1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: -13,
    y: 153,
    width: 24,
    height: 10,
    fill: "#87C6D4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: -21,
    y: 139,
    width: 40,
    height: 10,
    fill: "#87C6D4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: -1,
    cy: 112,
    r: 20,
    fill: "#87C6D4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 29,
    width: 200,
    height: 151,
    rx: 14,
    fill: "#87C6D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M266 81H466V166C466 173.732 459.732 180 452 180H280C272.268 180 266 173.732 266 166V81Z",
    fill: "#ABD7E1"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 41,
    width: 83,
    height: 16,
    fill: "#ABD7E1"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 61,
    width: 68,
    height: 10,
    fill: "#ABD7E1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 283,
    y: 139,
    width: 40,
    height: 10,
    fill: "#87C6D4"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 153,
    width: 24,
    height: 10,
    fill: "#87C6D4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 303,
    cy: 112,
    r: 20,
    fill: "#87C6D4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238 126L253.711 164.951L259.843 150.361L273.373 163.892L275.74 161.525L262.045 147.831L275.832 142.27L238 126Z",
    fill: "#AB1A1A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 200,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatterns);
export default __webpack_public_path__ + "static/media/patterns.eee94901b8e953a6ee526112c4b16a61.svg";
export { ForwardRef as ReactComponent };